'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$155(ps$87) {
  this.a6U = null;
  this.a6U = ps$87;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$155 as $c_Lmealorama_jsonCodecs$package$$anon$155 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$155.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$155;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$155() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$155 as $h_Lmealorama_jsonCodecs$package$$anon$155 };
$h_Lmealorama_jsonCodecs$package$$anon$155.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6U.a.length;
});
$p.g = (function(i) {
  return this.a6U.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$155 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$155, "mealorama.jsonCodecs$package$$anon$155", ({
  J7: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$155 as $d_Lmealorama_jsonCodecs$package$$anon$155 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$155.js.map
